import API from '../../../api/API';

export default class EventRegistryAPI extends API {
  constructor(parameters = {}) {
    super('/EventRegistry', parameters);
  }

  applyCommands(event, idInDb, useAdditionalValidation) {
    const url = `${this.endpoint}/ApplyCommands?useAdditionalValidation=${useAdditionalValidation}`;
    return this.submit("post", url, {...event, integrationEventIdList: idInDb});
  }

  getDirectoryEvents(contractId) {
    return this.submit("get", `${this.endpoint}/GetDirectoryEvents/${contractId}`);
  }

  getIntegrationEvents(contractId) {
    return this.submit("get", `${this.endpoint}/GetIntegrationEvents/${contractId}`);
  }

  getPreviousDirectoryEventIfExist(currentEventId) {
    return this.submit("get", `${this.endpoint}/GetPreviousDirectoryEventIfExist/${currentEventId}`);
  }

  removeLastEvent(eventId) {
    return this.submit("delete", `${this.endpoint}?eventId=${eventId}`);
  }

  rollBackLastEvent(eventId) {
    return this.submit("delete", `${this.endpoint}/Rollback?eventId=${eventId}`);
  }

  generateManualChartTemplate(manualCharts) {
    return this.export('post', `${this.endpoint}/ExportManualChart`, manualCharts);
  }

  parseManualChartFromExcel(data) {
    return this.submit("post", `${this.endpoint}/ParseManualChartFromExcel/${data.assetComponentId}`, data.file);
  }
}
